
import useHeaderMobileDetect from "@BUSADentalMarketing/hooks/useHeaderMobileDetect";
import { EagerLoadingLogoProvider } from "@insite/client-framework/Common/EagerLoadingLogo";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import Zone from "@insite/client-framework/Components/Zone";
import { GetPaymentProfilesApiParameter } from "@insite/client-framework/Services/AccountService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import {
    getLanguages,
    getSession,
    getSettingsCollection,
} from "@insite/client-framework/Store/Context/ContextSelectors";
import dismissRfqUpdates from "@insite/client-framework/Store/Context/Handlers/DismissRfqUpdates";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import loadPaymentProfiles from "@insite/client-framework/Store/Data/PaymentProfiles/Handlers/LoadPaymentProfiles";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import SkipNav, { SkipNavStyles } from "@insite/content-library/Components/SkipNav";
import { AutocompleteBrandsStyles } from "@insite/content-library/Widgets/Header/AutocompleteBrands";
import { AutocompleteCategoriesStyles } from "@insite/content-library/Widgets/Header/AutocompleteCategories";
import { AutocompleteContentStyles } from "@insite/content-library/Widgets/Header/AutocompleteContent";
import { AutocompleteProductsStyles } from "@insite/content-library/Widgets/Header/AutocompleteProducts";
import { AutocompleteSuggestionsStyles } from "@insite/content-library/Widgets/Header/AutocompleteSuggestions";
import { SearchHistoryStyles } from "@insite/content-library/Widgets/Header/SearchHistory";
// import SearchInput from "@BrasselerSurgical/Overrides/Widgets/Header/SearchInput";
import Button from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import Search from "@insite/mobius/Icons/Search";
import X from "@insite/mobius/Icons/X";
import Img from "@insite/mobius/Img";
import Link from "@insite/mobius/Link";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import { ContentBodyProps, OverflowWrapperProps, PopoverPresentationProps } from "@insite/mobius/Popover";
import { TextFieldPresentationProps } from "@insite/mobius/TextField";
import { HasToasterContext, withToaster } from "@insite/mobius/Toast/ToasterContext";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";

import BrasselerColors from "@tBrasseler/Utils/Colors";

import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";


const mapStateToProps = (state: ApplicationState) => {
    const session = getSession(state);
    const billtos = getBillToState(state, session.billToId);
    const setting = getSettingsCollection(state) as any;
    const guestCustomerNumber = setting.customSettingSettings.guestCustomerNumber;
    const customerNumber = billtos.value?.customerNumber;
    const pathname = getLocation(state).pathname;
    return {
        siteName: state.context.website.name,
        session,
        guestCustomerNumber,
        customerNumber,
        myAccountPageUrl: getPageLinkByPageType(state, "MyAccountPage")?.url,
        languages: getLanguages(state),
        pathname,
        pageType: getCurrentPage(state).type,
        location: getLocation(state),
        paymentProfilesData: state.data.paymentProfiles,
        // searchedQuery: state?.BrasselerSurgical?.SearchResults?.searchResult?.query || "",
    };
};

const mapDispatchToProps = {
    dismissRfqUpdates,
    loadPaymentProfiles,
};

type Props = PageProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasToasterContext &
    HasHistory &
    HasShellContext;

export interface HeaderStyles {
    page?: MobiusPageProps;
    container?: InjectableCss;
    logoZone?: InjectableCss;
    firstNavigationWrapper?: InjectableCss;
    firstNavigationItemsContainerWrapper?: InjectableCss;
    firstNavigationItemsContainer?: InjectableCss;
    navZone?: InjectableCss;
    searchZone?: InjectableCss;
    signInZone?: InjectableCss;
    signInZoneOnlyIcon?: InjectableCss;
    languageZone?: InjectableCss;
    cartZone?: InjectableCss;
    skipToContent?: SkipNavStyles;
    websiteName?: InjectableCss;
    mobileContainer?: InjectableCss;
    mobileContainerSticky?: InjectableCss;
    leftWrapper?: InjectableCss;
    rightWrapper?: InjectableCss;
    searchWrapper?: InjectableCss;
    myAccountWrapper?: InjectableCss;
    breadCrumbsWrapper?: InjectableCss;
    logo?: InjectableCss;
    desktopWrapper?: InjectableCss;
    navActions?: InjectableCss;
    searchActiveWrapper?: InjectableCss;
    searchInput?: InjectableCss;
    iconButton?: InjectableCss;
    signInButton?: InjectableCss;
    searchContainer?: InjectableCss;
    navActionsAnimated?: InjectableCss;

    rightContent?: InjectableCss;
    searchWrapperDesktop?: InjectableCss;
    navWrapperDesktop?: InjectableCss;
    secondaryNavigation?: InjectableCss;
    secondaryNavigationWrapper?: InjectableCss;
    secondNavigationItems?: InjectableCss;
    mobilenavbar?: InjectableCss;
}

export const headerStyles: HeaderStyles = {
    page: {
        fullWidth: [true, true, true, false, false],
        css: css`
           padding: 0px;
            /* position: sticky;
            top: 0;
            z-index: 1000; important */
            /* background: #fff; prevent transparency */
            /* box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.2); */
        `,
    },
    firstNavigationWrapper: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: end;
            background: linear-gradient(
                90deg,
                rgb(0, 26, 138) 0%,
                rgb(0, 70, 186) 42%,
                rgb(0, 104, 200) 75%,
                rgb(0, 159, 223) 100%
            );
        `,
    },
    firstNavigationItemsContainer: {
        css: css`
            display: flex;
            gap: 15px;
            font-weight: 400;
            color: white;
            text-transform: uppercase;
            font-size: 11px;
            height: 20px;
            
            a {
                border-right: 1px solid #fff;
                padding-right: 15px;
            }

            a:nth-child(2) {
            border-right: none;
            padding-right: 0;
            border-top: 1px solid #fff;
            border-bottom: 1px solid #fff;
        }
            a span,
            span[class*="TypographyStyle"],
            span[class*="StyledTypography"] {
                color: white !important;
            }
        `,
    },

    secondNavigationItems: {
        css: css`
            display: flex;
            gap: 15px;
            font-weight: 600;
            max-width: 1080px;
            margin: auto;
            margin-top: 15px;
            color: #595959 !important;
            a,
            a span,
            span[class*="TypographyStyle"],
            span[class*="StyledTypography"] {
                color: #595959 !important;
                /* color: white !important; */
            }
        `,
    },

    firstNavigationItemsContainerWrapper: {
        css: css`
            width: 80%;
            margin: auto;
            display: flex;
            justify-content: end;
            align-items: center;
            font-size: 12px;
            padding: 5px 0px;
            margin: auto;
            max-width: 980px;
            gap: 15px;
        `,
    },

    secondaryNavigationWrapper: {
        css: css`
            background: linear-gradient(
                90deg,
                rgb(0, 26, 138) 0%,
                rgb(0, 70, 186) 42%,
                rgb(0, 104, 200) 75%,
                rgb(0, 159, 223) 100%
            );
            /* line-height: 1em;
            padding-top: 0.75em; */
        `,
    },
    secondaryNavigation: {
        css: css`
            display: flex;
            justify-content: end;
            width: 80%;
            margin: auto;
            font-weight: 600;
        `,
    },

    container: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 80%;
            margin: auto;
            position: relative;
            /* padding: 15px 0px; */
            margin: auto;
            max-width: 980px;
        `,
    },

    /* 🔹 LOGO */
    logoZone: {
        css: css`
            width: 100%;
            display: flex;
            flex-direction: row; /* force horizontal */
            align-items: center;
            justify-content: space-between;

            > *:first-child {
                flex: 0 0 auto; /* logo doesn't grow */
            }

            > *:last-child {
                flex: 0 0 auto; /* hamburger doesn't grow */
                margin-left: auto; /* pushes to right */
            }
        `,
    },

    /* 🔹 RIGHT SIDE WRAPPER (desktop) */
    desktopWrapper: {
        css: css`
            flex: 1 1 auto;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            min-width: 0;
        `,
    },

    rightContent: {
        css: css`
            display: flex;
            align-items: center;
            flex: 1; /* allows search to grow */
            justify-content: flex-end;
            position: relative;
            min-width: 0;
        `,
    },

    searchWrapperDesktop: {
        css: css`
            display: flex;
            align-items: center;
            gap: 12px;
            width: 80%;
            min-height: 54px;
        `,
    },

    navWrapperDesktop: {
        css: css`
            display: flex;
            align-items: center;
            gap: 20px;
        `,
    },

    searchInput: {
        css: css`
            width: 100%;
            outline: none;
        `,
    },
    /* 🔹 NAV + ACTIONS ROW */
    navActions: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 18px;
            width: 100%;
        `,
    },

    /* 🔹 MAIN NAV */
    navZone: {
        css: css`
            display: flex;
            align-items: center;
            gap: 16px;
            flex: 1;
        `,
    },

    /* 🔹 SEARCH ACTIVE STATE */
    searchActiveWrapper: {
        css: css`
            display: flex;
            align-items: center;
            width: 100%;
            gap: 12px;
        `,
    },

    searchContainer: {
        css: css`
            position: relative;
            display: flex;
            align-items: center;
            width: 100%;
            overflow: hidden;
        `,
    },

    navActionsAnimated: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 18px;
            width: 100%;
            transition: all 0.35s ease;

            &.is-hidden {
                opacity: 0;
                transform: translateX(-10px);
                pointer-events: none;
            }
        `,
    },

    iconButton: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
        `,
    },

    signInButton: {
        css: css`
            white-space: nowrap;
            padding: 0 !important;
            border-radius: 5px;

            transition: 0.3s;
            padding: 0px 18px 0px 18px !important;
            min-height: 30px;
            span {
                font-weight: 500;
                font-size: 14px;
            }
        `,
    },

    /* 🔹 LEGACY ZONES (kept safe) */
    signInZone: {
        css: css`
            width: 12%;
            max-width: 150px;
            margin-left: 10px;
        `,
    },

    signInZoneOnlyIcon: {
        css: css`
            width: 6%;
            max-width: 56px;
            margin-left: 10px;
        `,
    },

    languageZone: {
        css: css`
            width: 6%;
            max-width: 66px;
        `,
    },

    cartZone: {
        css: css`
            width: 6%;
            max-width: 66px;
            display: flex;
            justify-content: flex-end;
            padding-left: 10px;
        `,
    },

    websiteName: {
        css: css`
            @media print {
                display: block;
            }
            font-size: 12px;
            padding-left: 15px;
            display: none;
        `,
    },

    /* 🔹 MOBILE */
    mobileContainer: {
        css: css`
            width: 80%;
            margin: auto;
            display: flex;
            height: 80px;

            justify-content: space-between;
            align-items: center;
            margin: auto;
            max-width: 1080px;
        `,
    },

    leftWrapper: {
        css: css`
            width: calc(60% - 15px);
            max-width: 250px;
        `,
    },

    rightWrapper: {
        css: css`
            max-width: 150px;
            padding-left: 10px;
        `,
    },

    searchWrapper: {
        css: css`
            width: 100%;
            margin-top: 20px;
        `,
    },

    myAccountWrapper: {
        css: css`
            width: 100%;
        `,
    },

    breadCrumbsWrapper: {
        css: css`
            width: 100%;

            .link-wrapper {
                .icon-wrapper {
                    margin: 0 10px !important;
                }

                span {
                    font-weight: 300;
                }

                .current-link {
                    font-weight: 500;
                }
            }
        `,
    },

    logo: {
        css: css`
            display: flex;
            justify-content: center;
            padding-top: 10px;

            .logo-wrapper-ca {
                max-width: 300px;
                margin-bottom: 5px;

                img {
                    max-width: 100%;
                }
            }
        `,
    },

    mobilenavbar: {
        css: css`
            display: flex;
            justify-content: space-between;
            align-items: center;
            /* width: 100%; */

            margin: 10px 20px;
        `,
    },
};
export interface SearchInputStyles {
    input?: TextFieldPresentationProps;
    popover?: PopoverPresentationProps;
    popoverWrapper?: OverflowWrapperProps;
    popoverContentBody?: ContentBodyProps;
    autocompleteWrapper?: InjectableCss;
    autocompleteColumnWrapper?: InjectableCss;
    autocompleteCommerceSearchWrapper?: InjectableCss;
    searchHistoryStyles?: SearchHistoryStyles;
    autocompleteSuggestionsStyles?: AutocompleteSuggestionsStyles;
    autocompleteCategoriesStyles?: AutocompleteCategoriesStyles;
    autocompleteBrandsStyles?: AutocompleteBrandsStyles;
    autocompleteContentStyles?: AutocompleteContentStyles;
    autocompleteProductsStyles?: AutocompleteProductsStyles;
}

const headerSearchInputStyles: SearchInputStyles = {
    input: {
        sizeVariant: "default",
        border: "underline",
        iconProps: {
            src: undefined as any,
            css: css`
                display: none;
            `,
        },
        cssOverrides: {
            formField: css`
                width: 100%;
            `,
            inputSelect: css`
                border: none;
                outline: none;
                padding: 8px 12px;
                font-size: 14px;
            `,
        },
    },
    popover: {
        transitionDuration: "regular",
        toggle: false,
    },
    popoverWrapper: {
        as: "div",
        _height: "auto",
        css: css`
            width: 100%;
        `,
    },
};

const enum fields {
    corporateBtnLabel = "corporateBtnLabel",
    corporateBtnLink = "corporateBtnLink",
    dentalBtnLabel = "dentalBtnLabel",
    dentalBtnLink = "dentalBtnLink",
    surgicalBtnLabel = "surgicalBtnLabel",
    surgicalBtnLink = "surgicalBtnLink",
    showSignInButton = "showSignInButton",
    signInButtonUrl = "signInButtonUrl",
}

const styles = headerStyles;

const Header = ({
    id,
    siteName,
    session,
    toaster,
    history,
    myAccountPageUrl,
    dismissRfqUpdates,
    languages,
    guestCustomerNumber,
    customerNumber,
    pathname,
    location,
    pageType,
    shellContext,
    paymentProfilesData,
    loadPaymentProfiles,
    fields,
    // searchedQuery,
}: Props) => {
    const { isMobileHeader } = useHeaderMobileDetect();
    const parameter: GetPaymentProfilesApiParameter = { pageSize: 999 };
    const [isSearchEnabled, setSearchEnabled] = useState<boolean>(false);
    const shouldShowSignInButton = fields.showSignInButton ?? true;

    const viewMyDashboardClickHandler = () => {
        if (myAccountPageUrl) {
            history.push(myAccountPageUrl);
        }
    };

    useEffect(() => {
        if (
            pathname.toLowerCase().includes("account") &&
            window.location.href.toLowerCase().includes("account") &&
            guestCustomerNumber === customerNumber
        ) {
            window.location.href = "/";
        }
    }, [guestCustomerNumber, customerNumber, pathname]);

    useEffect(() => {
        if (session.hasRfqUpdates && myAccountPageUrl) {
            toaster.addToast({
                body: (
                    <>
                        <Typography>{translate("You have new quote information.")}</Typography>
                        <Link onClick={viewMyDashboardClickHandler}>{translate("View My Dashboard")}</Link>
                    </>
                ),
                messageType: "info",
                timeoutLength: 1000 * 60 * 60 * 24 * 365,
                onClose: () => {
                    dismissRfqUpdates();
                },
            });
        }
    }, [myAccountPageUrl]);

    useEffect(() => {
        if (
            customerNumber &&
            customerNumber !== guestCustomerNumber &&
            Object.keys(paymentProfilesData.byId).length === 0
        ) {
            loadPaymentProfiles(parameter);
        }
    }, [customerNumber]);

    const afterHeader = React.createRef<HTMLSpanElement>();

    const openSearch = () => {
        setSearchEnabled(true);
    };

    const closeSearch = () => {
        setSearchEnabled(false);
    };

    const showSearchInput = isSearchEnabled;

    //     if (isMobileHeader === null) {
    //     return null; // or a header skeleton
    // }

    // if (isMobileHeader) {
    //     return (
    //         <Page as="header" isHeader={true} {...styles.page}>
    //             <SkipNav
    //                 extendedStyles={styles.skipToContent}
    //                 text={translate("Skip to main content")}
    //                 destination={afterHeader}
    //             />

    //         </Page>
    //     );
    // }

    return (
        <Page as="header" isHeader={true} {...styles.page}>
            <SkipNav
                extendedStyles={styles.skipToContent}
                text={translate("Skip to main content")}
                destination={afterHeader}
            />
            {isMobileHeader ? (
                <StyledWrapper {...styles.mobilenavbar}>
                    <StyledWrapper>
                        <Zone contentId={id} zoneName="Logo" />
                    </StyledWrapper>
                    <StyledWrapper>
                        <Zone contentId={id} zoneName="MainNavigation" />
                    </StyledWrapper>
                </StyledWrapper>
            ) : (
                <EagerLoadingLogoProvider value={true}>
                    <StyledWrapper>
                        {/**first navigation */}
                        {!isMobileHeader && (
                            <StyledWrapper {...styles.firstNavigationWrapper}>
                                <StyledWrapper {...styles.firstNavigationItemsContainerWrapper}>
                                    <StyledWrapper {...styles.firstNavigationItemsContainer}>
                                        <Link href={fields.corporateBtnLink || "#"} target="_blank">
                                            {fields.corporateBtnLabel}
                                        </Link>
                                        <Link href={fields.dentalBtnLink || "#"} target="_blank">
                                            {fields.dentalBtnLabel}
                                        </Link>
                                        <Link href={fields.surgicalBtnLink || "#"} target="_blank">
                                            {fields.surgicalBtnLabel}
                                        </Link>
                                    </StyledWrapper>
                                    <StyledWrapper>
                                        <Zone contentId={id} zoneName="Search" />
                                    </StyledWrapper>
                                </StyledWrapper>
                            </StyledWrapper>
                        )}
                        {/**second navigation */}
                    </StyledWrapper>
                    {session.isAuthenticated && !isMobileHeader && <Zone contentId={id} zoneName="MyAccount" />}

                    <Zone contentId={id} zoneName="Breadcrumb" />
                    {!isMobileHeader && (
                        <StyledWrapper>
                            <Zone contentId={id} zoneName="MainNavigation" />
                        </StyledWrapper>
                    )}
                </EagerLoadingLogoProvider>
            )}

            <span ref={afterHeader} tabIndex={-1} />
        </Page>
    );
};

export const HeaderContext = "HeaderContext";

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withToaster(withHistory(withIsInShell(Header)))),
    definition: {
        hasEditableTitle: false,
        hasEditableUrlSegment: false,
        pageType: "System",
        fieldDefinitions: [
            {
                fieldType: "Translatable",
                name: fields.corporateBtnLabel,
                editorTemplate: "TextField",
                displayName: "Corporate Button Label",
                defaultValue: "",
            },
            {
                fieldType: "Translatable",
                name: fields.corporateBtnLink,
                editorTemplate: "TextField",
                displayName: "Corporate Button Link",
                defaultValue: "",
            },
            {
                fieldType: "Translatable",
                name: fields.dentalBtnLabel,
                editorTemplate: "TextField",
                displayName: "Dental Button Lable",
                defaultValue: "",
            },
            {
                fieldType: "Translatable",
                name: fields.dentalBtnLink,
                editorTemplate: "TextField",
                displayName: "Dental Button Link",
                defaultValue: "",
            },
            {
                fieldType: "Translatable",
                name: fields.surgicalBtnLabel,
                editorTemplate: "TextField",
                displayName: "Surgical Button Lable",
                defaultValue: "",
            },
            {
                fieldType: "Translatable",
                name: fields.surgicalBtnLink,
                editorTemplate: "TextField",
                displayName: "Surgical Button Link",
                defaultValue: "",
            },
            {
                fieldType: "General",
                name: fields.showSignInButton,
                editorTemplate: "CheckboxField",
                displayName: "Show Sign In Button",
                defaultValue: true,
            },
            {
                fieldType: "General",
                name: fields.signInButtonUrl,
                editorTemplate: "TextField",
                displayName: "Sign In Button URL",
                defaultValue: "",
            },
        ],
    },
};

export default pageModule;
